import { Checkbox, type CheckboxProps } from '@progress/kendo-react-inputs'
import React from 'react'

import { useLogEvent } from '~/hooks/useLogEvent'

type ColumnDisplayToggleItem<ColumnKey extends string> = {
  columnKey: ColumnKey
  isVisible: boolean
  label: string
}

export type ColumnDisplayToggleFormItemProps<ColumnKey extends string> = {
  item: ColumnDisplayToggleItem<ColumnKey>
  onChange?: (value: boolean, columnKeys: ColumnKey[]) => void
}

export const ColumnDisplayToggleFormItem = <ColumnKey extends string>({
  item,
  onChange,
}: ColumnDisplayToggleFormItemProps<ColumnKey>) => {
  const logEvent = useLogEvent()

  const handleChange = React.useCallback<EH<CheckboxProps, 'onChange'>>(
    (event) => {
      onChange?.(event.value, [item.columnKey])

      logEvent('Turn onoff', { withAnalysisName: true, withSuffix: true })
    },
    [item.columnKey, logEvent, onChange],
  )

  return (
    <Checkbox
      checked={item.isVisible}
      label={item.label}
      onChange={handleChange}
    />
  )
}
